import { makeApiCallWithAny } from "./tokenService";
import { IWorkTimeType } from "../models/workShiftTimeSlot/workTimeType";
import { IWorkTimeStartFormItem } from "../models/workShiftTimeSlot/workTimeStartFormItem";
import { SaveSuccess } from "./baseService";
import { IWorkShiftTimeSlotItems } from "../models/workShiftTimeSlot/workShiftTimeSlotItems";
import { IWorkShiftTimeSlot } from "../models/workShiftTimeSlot/workShiftTimeSlot";
import { IWorkTimeSaveData } from "../models/workShiftTimeSlot/workTimeSaveData";
import { IWorkTimeFinishData } from "../models/workShiftTimeSlot/workTimeFinishData";
import { ISalaryRowType } from "../models/salaryRowType/salaryRowType";
import { GeolocationPosition } from "../models/workShiftTimeSlot/workTimeStartFormItem";
import { NonOverlappingWorkShiftTimeSlotSaveData } from "../models/workShiftTimeSlot/nonOverlappingWorkShiftTimeSlotSaveData";
import { IWorkTimeCommentSaveData } from "../models/workShiftTimeSlot/workTimeCommentSaveData";

export interface WorkShiftTimeSlotStartResult {
    finishedSlotId: string | null;
    newSlot: IWorkShiftTimeSlot;
}

export const startWorkTime = (
    data: IWorkTimeStartFormItem
): Promise<WorkShiftTimeSlotStartResult> => {
    return makeApiCallWithAny<WorkShiftTimeSlotStartResult>(
        "api/workshifttimeslot/start?v=2",
        null,
        "POST",
        data
    );
};
export const finishWorkTime = (
    data: IWorkTimeFinishData
): Promise<IWorkShiftTimeSlot> => {
    return makeApiCallWithAny<IWorkShiftTimeSlot>(
        "api/workshifttimeslot/finish",
        null,
        "POST",
        data
    );
};

export const saveWorkTimeLocation = (
    workShiftTimeSlotId: string,
    location: GeolocationPosition,
    type: "start" | "finish"
): Promise<SaveSuccess> => {
    return makeApiCallWithAny<SaveSuccess>(
        `api/workshifttimeslot/${workShiftTimeSlotId}/location/${type}`,
        null,
        "POST",
        location
    );
};

export const getWorkTimeTypes = (
    signal: AbortSignal
): Promise<IWorkTimeType[]> => {
    return makeApiCallWithAny<IWorkTimeType[]>(
        "api/workshifttimeslot/worktimetypes",
        signal
    );
};

export const getWorkShiftTimeSlotItems = (
    startDate: string,
    endDate: string,
    signal: AbortSignal
): Promise<IWorkShiftTimeSlotItems> => {
    return makeApiCallWithAny<IWorkShiftTimeSlotItems>(
        `api/workshifttimeslots?startDate=${encodeURIComponent(
            startDate
        )}&endDate=${encodeURIComponent(endDate)}`,
        signal
    );
};

export const getWorkShiftTimeSlotItem = (
    id: string,
    signal: AbortSignal
): Promise<IWorkShiftTimeSlot> => {
    return makeApiCallWithAny<IWorkShiftTimeSlot>(
        `api/workshifttimeslot/${encodeURIComponent(id)}`,
        signal
    );
};

export const getSalaryRowTypes = (
    signal: AbortSignal
): Promise<ISalaryRowType[]> => {
    return makeApiCallWithAny<ISalaryRowType[]>(
        "api/workshifttimeslot/salaryrowtypes",
        signal
    );
};

export const saveWorkTime = (
    data: IWorkTimeSaveData,
    validateOverlapping = false
): Promise<IWorkShiftTimeSlot> => {
    const queryString = new URLSearchParams({
        validateOverlapping: validateOverlapping.toString(),
    }).toString();
    return makeApiCallWithAny<IWorkShiftTimeSlot>(
        `api/workshifttimeslot/save?${queryString}`,
        null,
        "POST",
        data
    );
};

export const saveWorkTimeComment = (
    data: IWorkTimeCommentSaveData
): Promise<IWorkShiftTimeSlot> => {
    return makeApiCallWithAny<IWorkShiftTimeSlot>(
        "api/workshifttimeslot/comment/save",
        null,
        "POST",
        data
    );
};

export const overwritingBreakSave = (
    data: NonOverlappingWorkShiftTimeSlotSaveData
): Promise<IWorkShiftTimeSlot> => {
    return makeApiCallWithAny<IWorkShiftTimeSlot>(
        "api/workshifttimeslot/nonoverlappingsave",
        null,
        "POST",
        data
    );
};

export const deleteWorkShiftTimeSlot = (
    workShiftTimeSlotId: string
): Promise<boolean> => {
    return makeApiCallWithAny<boolean>(
        `api/workshifttimeslot/delete/${encodeURIComponent(
            workShiftTimeSlotId
        )}`,
        null,
        "DELETE"
    );
};

export const deleteCategoryFromWorkShiftTimeSlot = (
    id: string,
    category: string,
    restore: boolean
): Promise<void> => {
    return makeApiCallWithAny<void>(
        `api/workshifttimeslot/${encodeURIComponent(
            id
        )}/ignorecategory/${category}?restore=${encodeURIComponent(
            restore.toString()
        )}`,
        null,
        "POST"
    );
};
